import { HttpErrorResponse } from '@angular/common/http';
import {Component, OnInit, OnDestroy} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef} from '@angular/material/dialog';
import { Subject } from 'rxjs';
import {  takeUntil } from 'rxjs/operators';
import endpoints from 'src/app/helpers/endpoints';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-find-agreement-number-modal',
  templateUrl: './find-agreement-number-modal.component.html',
  styleUrls: ['./find-agreement-number-modal.component.scss']
})
export class FindAgreementNumberModalComponent implements OnInit, OnDestroy {

  searchByForm!: FormGroup;
  agreementNumberForm!: FormGroup;
  ngUnsubscribe =  new Subject<void>();
  serviceAgreement:any[] = [];
  showAgreementForm !: boolean;
  constructor(
    private dialogRef: MatDialogRef<FindAgreementNumberModalComponent>,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.formInit();
    this.searchByForm.get('searchBy')?.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
      const phoneNumberControl = this.searchByForm.get('phoneNumber');
      const emailAddressControl = this.searchByForm.get('emailAddress');
     if(phoneNumberControl && emailAddressControl) {
      if(res === 'phoneNumber'){
       phoneNumberControl.setValidators([ Validators.required, Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/),]);
       emailAddressControl.clearValidators()
      } else if(res === 'emailAddress') {
      emailAddressControl.setValidators([ Validators.required, Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/)]);
      phoneNumberControl.clearValidators();
      } else {
        phoneNumberControl.clearValidators();
        emailAddressControl.clearValidators();
      }
      emailAddressControl.updateValueAndValidity();
      phoneNumberControl.updateValueAndValidity();
     }
    })
  }
  formInit(){
    this.searchByForm = new FormGroup({
      searchBy: new FormControl('', [Validators.required]),
      emailAddress: new FormControl(''),
      phoneNumber: new FormControl('')
    });
    this.agreementNumberForm = new FormGroup({
      serviceAgreementNumber: new FormControl('', [Validators.required])
    })
  }
  closeDialog() {
    this.dialogRef.close();
  };
  getAgreementdata(){
   if(this.searchByForm.valid){
    let keyWord!:string;
    if(this.searchByForm.value?.searchBy === 'phoneNumber'){
      keyWord = this.searchByForm.value?.phoneNumber;
    } else if(this.searchByForm.value?.searchBy === 'emailAddress'){
      keyWord = this.searchByForm.value?.emailAddress;
    }
    this.showAgreementForm = false;
    this.apiService.get(endpoints.fileAClaim.getServiceAgreementList(this.searchByForm.value?.searchBy, keyWord)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
      if(res?.body?.agreements && res?.body?.agreements?.length > 0){
        this.serviceAgreement = res?.body?.agreements;
        this.showAgreementForm = true;
      } else {
        this.showAgreementForm = false;
        this.apiService.alert("Cant't find any agreement number using this email address or phone number", 'error');
      }
    }, (err: HttpErrorResponse)=>{
      this.apiService.alert(err.message, 'error');
      this.showAgreementForm = false;
    })
   } else {
    this.searchByForm.markAllAsTouched();
   }
  };
  getParticularAgreementData(){
    if(this.agreementNumberForm.valid){
        this.dialogRef.close(this.agreementNumberForm.value.serviceAgreementNumber);
        this.apiService.alert('You successfully find your agreement number', 'success');
    } else {
      this.agreementNumberForm.markAllAsTouched();
    }
  };
  changeEmailAndSet() {
    this.searchByForm.controls['emailAddress'].patchValue(this.searchByForm.value.emailAddress.replace(/\s+/g, ''))
  };

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
